import React from "react";
import classNames from "classnames";

import { Text } from "../text";
import { GoogleIcon } from "../../assets/icons";

import "./GoogleReviewSection.scss";

type Props = {
    isLargeTitle?: boolean;
    businessPlaceId?: string;
    onClick?: () => void;
};

export const GoogleReviewSection = ({ isLargeTitle, businessPlaceId, onClick }: Props) => {
    const href = businessPlaceId
        ? `https://search.google.com/local/writereview?placeid=${businessPlaceId ?? ""}`
        : "https://developers.google.com/maps/documentation/places/web-service/place-id";

    const handleClick = () => {
        onClick?.();
    };

    return (
        <div className="google-review-container">
            <div className="google-review-header">
                <Text
                    preset={isLargeTitle ? "title-28" : "g-16"}
                    mode="bold"
                    value="Thanks for your feedback"
                    className={classNames("google-review-button__title", isLargeTitle && "large")}
                />
                <Text preset="g-14">Help us get discovered by leaving a Google review.</Text>
            </div>
            <div className="google-review-content">
                <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                    <button className="google-review-button">
                        <GoogleIcon />
                        <span>Review us on Google</span>
                    </button>
                </a>
            </div>
        </div>
    );
};
